import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cte_documentos = _resolveComponent("cte-documentos")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_cte_impostos = _resolveComponent("cte-impostos")!
  const _component_cte_detalhe_financeiro = _resolveComponent("cte-detalhe-financeiro")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_tab_pane, {
        key: "1",
        tab: "Documentos Referenciados"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_cte_documentos, {
            documentos: _ctx.documentos,
            valorFrete: _ctx.valorFrete,
            editavel: _ctx.editavel,
            "onUpdate:documentos": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:documentos', value))
          }, null, 8, ["documentos", "valorFrete", "editavel"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_tab_pane, {
        key: "2",
        tab: "Impostos"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_cte_impostos, {
            imposto: _ctx.impostoModel,
            "onUpdate:imposto": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.impostoModel) = $event)),
            empresa: _ctx.empresa,
            codigoTipoOperacao: _ctx.codigoTipoOperacao,
            codigoPessoa: _ctx.codigoPessoa,
            editavel: _ctx.editavel
          }, null, 8, ["imposto", "empresa", "codigoTipoOperacao", "codigoPessoa", "editavel"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_tab_pane, {
        key: "3",
        tab: "Pagamento"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_cte_detalhe_financeiro, {
            empresa: _ctx.empresa,
            editavel: _ctx.editavel,
            detalhesPagamento: _ctx.detalhesPagamentoModel,
            "onUpdate:detalhesPagamento": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detalhesPagamentoModel) = $event))
          }, null, 8, ["empresa", "editavel", "detalhesPagamento"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}